enum TrackerStatus {
  Normal = 'Normal',
  Warning = 'Warning',
  Error = 'Error',
}

export default TrackerStatus;
